// import React, { useState, useEffect } from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { BiSolidDashboard } from "react-icons/bi";
// import { IoStorefront } from "react-icons/io5";
// import { GrCatalog } from "react-icons/gr";
// import {
//   MdOutlineSupportAgent,
//   MdOutlineWifiProtectedSetup,
// } from "react-icons/md";
// import { useUser } from "../config/userProvider";
// import { BiSolidOffer } from "react-icons/bi";
// import { IoStorefrontOutline } from "react-icons/io5";
// import { RiTeamFill } from "react-icons/ri";
// import { VscBroadcast } from "react-icons/vsc";
// import { IoIosPeople } from "react-icons/io";
// import { IoAppsSharp } from "react-icons/io5";
// import "../../src/App.css";
// import { BsViewList } from "react-icons/bs";
// import { IoSettingsOutline } from "react-icons/io5";
// import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
// import { MdOutlineLoyalty } from "react-icons/md";
// import { AiOutlineProduct } from "react-icons/ai";
// import { useTheme } from "../config/themeContext";
// // import "./sidebar.css";
// // import Hamburger from "./burger-menu-svgrepo-com.svg";
// // import Close from "./close-svgrepo-com.svg";
// // import { FaRegFolder, FaUserPlus } from "react-icons/fa6";
// // import { TbBrandGoogleAnalytics, TbViewfinder } from "react-icons/tb";
// // import { FaUsersViewfinder } from "react-icons/fa6";
// // import { BiCategoryAlt } from "react-icons/bi";
// // import { PiFilePdfLight } from "react-icons/pi";
// // import { RiEdit2Line } from "react-icons/ri";
// // import { IoIosAddCircleOutline } from "react-icons/io";

// const Sidebar = () => {
//   const { userData } = useUser();
//   const [openDropdowns, setOpenDropdowns] = useState({}); // Store dropdown states by item title
//   const location = useLocation();
//   // useEffect(() => {
//   //   // Automatically open the relevant dropdown if the current route matches a subMenu item
//   //   const updatedOpenDropdowns = {};

//   //   NavigationData[userData?.userType].forEach((item) => {
//   //     if (
//   //       item.subMenu &&
//   //       item.subMenu.some((subItem) => subItem.location === location.pathname)
//   //     ) {
//   //       updatedOpenDropdowns[item.title] = true; // Open the dropdown for the matched menu
//   //     }
//   //   });

//   //   setOpenDropdowns(updatedOpenDropdowns);
//   // }, [location.pathname, userData?.userType]);

//   // useEffect(() => {
//   //   if (!NavigationData[userData?.userType]) return;

//   //   const updatedOpenDropdowns = {};

//   //   NavigationData[userData?.userType].forEach((item) => {
//   //     if (
//   //       item.subMenu &&
//   //       item.subMenu.some((subItem) => subItem.location === location.pathname)
//   //     ) {
//   //       updatedOpenDropdowns[item.title] = true;
//   //     }
//   //   });

//   //   setOpenDropdowns(updatedOpenDropdowns);
//   // }, [location.pathname, userData?.userType]);

//   useEffect(() => {
//     const menu = NavigationData[userData?.userType];
//     if (!menu) return;

//     const updatedOpenDropdowns = menu.reduce((acc, item) => {
//       if (
//         item.subMenu?.some((subItem) => subItem.location === location.pathname)
//       ) {
//         acc[item.title] = true;
//       }
//       return acc;
//     }, {});

//     setOpenDropdowns(updatedOpenDropdowns);
//   }, [location.pathname, userData?.userType]);

//   const toggleDropdown = (title) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [title]: !prev[title],
//     }));
//   };

//   const NavigationData = {
//     master: [
//       {
//         title: "Dashboard",
//         icon: <BiSolidDashboard />,
//         location: "/dashboard",
//       },
//       // {
//       //   title: "Analytics",
//       //   icon: <TbBrandGoogleAnalytics />,
//       //   location: "/analytics",
//       // },
//       {
//         title: "Teams",
//         icon: <RiTeamFill />,
//         location: "/teams",
//       },
//       {
//         title: "Vendors",
//         icon: <IoStorefront />,
//         location: "/vendors",
//       },
//       {
//         title: "Demos",
//         icon: <BsViewList />,
//         location: "/demos",
//       },
//       {
//         title: "Support",
//         icon: <MdOutlineSupportAgent />,
//         location: "/support",
//       },
//       {
//         title: "Setting",
//         icon: <IoSettingsOutline />,
//         location: "/setting",
//       },
//     ],
//     superadmin: [
//       {
//         title: "Dashboard",
//         icon: <BiSolidDashboard />,
//         location: "/dashboard",
//       },
//       {
//         title: "Create catalog",
//         icon: <GrCatalog />,
//         location: "/createcatalog",
//       },
//       // {
//       //   title: "Files",
//       //   icon: <FaRegFolder />,
//       //   location: "/files",
//       // },
//       // {
//       //   title: "Customers",
//       //   icon: <IoIosPeople />,
//       //   dropdown: true,
//       //   subMenu: [
//       //     { title: "Customers", location: "/customers/all" },
//       //     // { title: "Segments", location: "/customers/segments" },
//       //   ],
//       // },
//       {
//         title: "Customers",
//         icon: <IoIosPeople />,
//         location: "/customers/all",
//       },
//       {
//         title: "Products",
//         icon: <AiOutlineProduct />,
//         location: "/products",
//       },
//       {
//         title: "Stores",
//         icon: <IoStorefrontOutline />,
//         location: "/stores",
//       },
//       // {
//       //   title: "Orders",
//       //   icon: <IoAppsSharp />,
//       //   location: "/orders",
//       // },
//       {
//         title: "Offers",
//         icon: <BiSolidOffer />,
//         location: "/offers",
//       },
//       // {
//       //   title: "Leaderboard",
//       //   icon: <MdLeaderboard />,
//       //   location: "/leaderboard",
//       // },
//       // {
//       //   title: "Analytics",
//       //   icon: <TbBrandGoogleAnalytics />,
//       //   dropdown: true,
//       //   subMenu: [
//       //     { title: "Overview", location: "/analytics/overview" },
//       //     { title: "Top Insights", location: "/analytics/insights" },
//       //     { title: "Report", location: "/analytics/report" },
//       //     { title: "Leaderboard", location: "/analytics/leaderboard" },
//       //   ],
//       // },
//       {
//         title: "Broadcasts",
//         icon: <VscBroadcast />,
//         location: "/broadcasts",
//       },
//       {
//         title: "Loyalty",
//         icon: <MdOutlineLoyalty />,
//         location: "/loyalty",
//       },
//       // {
//       //   title: "Image editor",
//       //   icon: <RiEdit2Line />,
//       //   location: "/imageeditor",
//       // },
//       {
//         title: "Teams",
//         icon: <RiTeamFill />,
//         location: "/teams",
//       },
//       {
//         title: "Support",
//         icon: <MdOutlineSupportAgent />,
//         location: "/support",
//       },
//       // {
//       //   title: "Apps",
//       //   icon: <IoAppsSharp />,
//       //   location: "/apps",
//       // },
//       {
//         title: "Integration",
//         icon: <MdOutlineWifiProtectedSetup />,
//         location: "/integration",
//       },
//       {
//         title: "Settings",
//         icon: <IoSettingsOutline />,
//         location: "/settings",
//         dropdown: true,
//         subMenu: [
//           { title: "Documents", location: "/settings/documents" },
//           { title: "Appearance", location: "/settings/appearance" },
//           { title: "My Plan", location: "/settings/myplan" },
//         ],
//       },
//     ],
//     admin: [
//       {
//         title: "Dashboard",
//         icon: <BiSolidDashboard />,
//         location: "/dashboard",
//       },
//       {
//         title: "Create catalog",
//         icon: <GrCatalog />,
//         location: "/createcatalog",
//       },
//       {
//         title: "Products",
//         icon: <AiOutlineProduct />,
//         location: "/products",
//       },
//       {
//         title: "Stores",
//         icon: <IoStorefrontOutline />,
//         location: "/stores",
//       },
//       {
//         title: "Orders",
//         icon: <IoAppsSharp />,
//         location: "/orders",
//       },
//       // {
//       //   title: "Analytics",
//       //   icon: <TbBrandGoogleAnalytics />,
//       //   location: "/analytics",
//       // },
//       // {
//       //   title: "Image editor",
//       //   icon: <RiEdit2Line />,
//       //   location: "/imageeditor",
//       // },
//       {
//         title: "Teams",
//         icon: <RiTeamFill />,
//         location: "/teams",
//       },
//       {
//         title: "Customers",
//         icon: <IoIosPeople />,
//         location: "/customers",
//       },
//       {
//         title: "Offers",
//         icon: <BiSolidOffer />,
//         location: "/offers",
//       },
//       {
//         title: "Support",
//         icon: <MdOutlineSupportAgent />,
//         location: "/support",
//       },
//       {
//         title: "Settings",
//         icon: <IoSettingsOutline />,
//         location: "/settings",
//         dropdown: true,
//         subMenu: [
//           { title: "Documents", location: "/settings/documents" },
//           { title: "Appearance", location: "/settings/appearance" },
//           { title: "My Plan", location: "/settings/myplan" },
//         ],
//       },
//     ],
//     user: [
//       // Store
//       {
//         title: "Dashboard",
//         icon: <BiSolidDashboard />,
//         location: "/dashboard",
//       },
//       {
//         title: "Create catalog",
//         icon: <GrCatalog />,
//         location: "/createcatalog",
//       },
//       {
//         title: "Support",
//         icon: <MdOutlineSupportAgent />,
//         location: "/support",
//       },
//       // {
//       //   title: "Setting",
//       //   icon: <IoSettingsOutline />,
//       //   location: "/setting",
//       // },
//     ],
//   };

//   const { theme } = useTheme();
//   console.log("theme sidebar", theme);
//   const { sideBar } = theme;

//   console.log(
//     "sidebar sidebar",
//     NavigationData[userData?.userType].map((item, index) =>
//       userData.permissions[item?.title?.toLowerCase()] === false
//         ? "not print"
//         : item.title,
//     ),
//   );

//   return (
//     <>
//       <div className="flex flex-col gap-1 items-center w-full h-full overflow-scroll py-2">
//         {NavigationData[userData?.userType].map((item, index) =>
//           userData.permissions[item?.title?.toLowerCase()] === false ? (
//             ""
//           ) : (
//             <div key={index} className="w-full">
//               {!item.dropdown ? (
//                 <NavLink
//                   style={({ isActive }) => ({
//                     backgroundColor: isActive
//                       ? sideBar?.activeNavBgColour
//                       : sideBar?.bgColour,
//                     color: isActive
//                       ? sideBar?.activeNavTextColour
//                       : sideBar?.textColour,
//                   })}
//                   className={({ isActive }) =>
//                     `-isActive-${isActive}- px-2 py-2 rounded-lg w-full flex border border-transparent items-center gap-1.5 
//                  text-sm ${
//                    isActive
//                      ? "bg-white text-black"
//                      : "hover:border hover:border-white text-white"
//                  }`
//                   }
//                   to={item.location}
//                 >
//                   <span className="text-xl">{item.icon}</span>
//                   <p className="sm:hidden lg:block">{item.title}</p>
//                 </NavLink>
//               ) : (
//                 <div
//                   className={
//                     openDropdowns[item.title]
//                       ? `border-x border-b rounded-lg bg-[#0d0808]`
//                       : ""
//                   }
//                 >
//                   <button
//                     onClick={() => toggleDropdown(item.title)}
//                     style={{
//                       backgroundColor: openDropdowns[item.title]
//                         ? sideBar?.activeNavBgColour
//                         : sideBar?.bgColour,
//                       color: openDropdowns[item.title]
//                         ? sideBar?.activeNavTextColour
//                         : sideBar?.textColour,
//                     }}
//                     className={`px-2 py-2 rounded-lg w-full flex items-center justify-between gap-1.5 
//                   text-sm transition-colors duration-700 border border-transparent ${
//                     openDropdowns[item.title]
//                       ? "bg-white text-black "
//                       : "text-white"
//                   } hover:bg-black hover:text-white hover:border hover:border-white`}
//                   >
//                     <div className="flex items-center gap-1.5">
//                       <span className="text-xl">{item.icon}</span>
//                       <p className="sm:hidden lg:block">{item.title}</p>
//                     </div>
//                     <span className="text-lg">
//                       {openDropdowns[item.title] ? (
//                         <CiCircleMinus />
//                       ) : (
//                         <CiCirclePlus />
//                       )}
//                     </span>
//                   </button>

//                   {openDropdowns[item.title] && (
//                     <div
//                       className={`ml-3 mr-1 my-2 space-y-1 overflow-hidden transition-all duration-700`}
//                     >
//                       {item.subMenu.map((subItem, subIndex) => (
//                         <NavLink
//                           key={subIndex}
//                           className={({ isActive }) =>
//                             `my-2 block px-2 py-2 rounded-lg w-full text-sm transition-colors duration-700 ${
//                               isActive
//                                 ? "bg-gray-300 text-black"
//                                 : "hover:bg-gray-700 text-white"
//                             }`
//                           }
//                           to={subItem.location}
//                         >
//                           {subItem.title}
//                         </NavLink>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           ),
//         )}
//       </div>

//       {/* <div className="flex flex-col gap-1 items-center w-full h-full overflow-scroll scroll-smooth hide-scrollbar py-2">
//       {NavigationData[userData?.userType].map((item, index) => {
//         return (
//           <NavLink
//             key={index}
//             style={{ borderWidth: 1 }} //due to bootstrap won't able to change border color;
//             onClick={() => (isMenuOpen ? setIsMenuOpen(false) : "")} // close menu if the isMenuOpen is true;
//             className={({ isActive }) => `
//               px-2 py-2 rounded-lg w-full  flex items-center gap-1.5
//                 border-transparent hover:border-[#353a40] capitalize
//                 text-sm
//              ${
//                isActive
//                  ? "bg-white/100  text-black/100  hover:text-inherit"
//                  : "hover:border hover:border-white  hover:text-white  text-white/100 "
//              }  
//               `}
//             to={item?.location}
//           >
//             <span className="text-xl"> {item?.icon}</span>
//             <p className=" sm:hidden lg:block">{item?.title}</p>
//           </NavLink>
//         );
//       })}
//     </div> */}
//     </>
//   );
// };

// export default Sidebar;














import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { BiSolidDashboard } from "react-icons/bi";
import { IoStorefront } from "react-icons/io5";
import { GrCatalog } from "react-icons/gr";
import { MdOutlineSupportAgent, MdOutlineWifiProtectedSetup } from "react-icons/md";
import { useUser } from "../config/userProvider";
import { BiSolidOffer } from "react-icons/bi";
import { IoStorefrontOutline } from "react-icons/io5";
import { RiTeamFill } from "react-icons/ri";
import { VscBroadcast } from "react-icons/vsc";
import { IoIosPeople } from "react-icons/io";
import { IoAppsSharp } from "react-icons/io5";
import { BsViewList } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { MdOutlineLoyalty } from "react-icons/md";
import { AiOutlineProduct } from "react-icons/ai";
import { useTheme } from "../config/themeContext";

// Moved outside component to prevent re-creation on every render
const NavigationData = {
  master: [
    { title: "Dashboard", icon: <BiSolidDashboard />, location: "/dashboard" },
    { title: "Teams", icon: <RiTeamFill />, location: "/teams" },
    { title: "Vendors", icon: <IoStorefront />, location: "/vendors" },
    { title: "Demos", icon: <BsViewList />, location: "/demos" },
    { title: "Support", icon: <MdOutlineSupportAgent />, location: "/support" },
    { title: "Setting", icon: <IoSettingsOutline />, location: "/setting" },
  ],
  superadmin: [
    { title: "Dashboard", icon: <BiSolidDashboard />, location: "/dashboard" },
    { title: "Create catalog", icon: <GrCatalog />, location: "/createcatalog" },
    { title: "Customers", icon: <IoIosPeople />, location: "/customers/all" },
    { title: "Products", icon: <AiOutlineProduct />, location: "/products" },
    { title: "Stores", icon: <IoStorefrontOutline />, location: "/stores" },
    { title: "Offers", icon: <BiSolidOffer />, location: "/offers" },
    { title: "Broadcasts", icon: <VscBroadcast />, location: "/broadcasts" },
    { title: "Loyalty", icon: <MdOutlineLoyalty />, location: "/loyalty" },
    { title: "Teams", icon: <RiTeamFill />, location: "/teams" },
    { title: "Support", icon: <MdOutlineSupportAgent />, location: "/support" },
    { title: "Integration", icon: <MdOutlineWifiProtectedSetup />, location: "/integration" },
    {
      title: "Settings",
      icon: <IoSettingsOutline />,
      location: "/settings",
      dropdown: true,
      subMenu: [
        { title: "Documents", location: "/settings/documents" },
        { title: "Appearance", location: "/settings/appearance" },
        { title: "My Plan", location: "/settings/myplan" },
      ],
    },
  ],
  admin: [
    { title: "Dashboard", icon: <BiSolidDashboard />, location: "/dashboard" },
    { title: "Create catalog", icon: <GrCatalog />, location: "/createcatalog" },
    { title: "Products", icon: <AiOutlineProduct />, location: "/products" },
    { title: "Stores", icon: <IoStorefrontOutline />, location: "/stores" },
    { title: "Orders", icon: <IoAppsSharp />, location: "/orders" },
    { title: "Teams", icon: <RiTeamFill />, location: "/teams" },
    { title: "Customers", icon: <IoIosPeople />, location: "/customers" },
    { title: "Offers", icon: <BiSolidOffer />, location: "/offers" },
    { title: "Support", icon: <MdOutlineSupportAgent />, location: "/support" },
    {
      title: "Settings",
      icon: <IoSettingsOutline />,
      location: "/settings",
      dropdown: true,
      subMenu: [
        { title: "Documents", location: "/settings/documents" },
        { title: "Appearance", location: "/settings/appearance" },
        { title: "My Plan", location: "/settings/myplan" },
      ],
    },
  ],
  user: [
    { title: "Dashboard", icon: <BiSolidDashboard />, location: "/dashboard" },
    { title: "Create catalog", icon: <GrCatalog />, location: "/createcatalog" },
    { title: "Support", icon: <MdOutlineSupportAgent />, location: "/support" },
  ],
};

const Sidebar = () => {
  const { userData } = useUser();
  const [openDropdowns, setOpenDropdowns] = useState({});
  const location = useLocation();
  const { theme } = useTheme();
  const { sideBar } = theme || {};

  // Auto-open dropdown if current route is inside submenu
  useEffect(() => {
    const menu = NavigationData[userData?.userType];
    if (!menu) return;

    const updatedOpenDropdowns = menu.reduce((acc, item) => {
      if (item.subMenu?.some((sub) => sub.location === location.pathname)) {
        acc[item.title] = true;
      }
      return acc;
    }, {});

    setOpenDropdowns(updatedOpenDropdowns);
  }, [location.pathname, userData?.userType]);

  const toggleDropdown = (title) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <div className="flex flex-col gap-1 items-center w-full h-full overflow-scroll py-2">
      {NavigationData[userData?.userType]?.map((item, index) => {
        // Hide menu item if permission is false
        if (userData?.permissions?.[item?.title?.toLowerCase()] === false) {
          return null;
        }

        return (
          <div key={index} className="w-full">
            {!item.dropdown ? (
              <NavLink
                to={item.location}
                style={({ isActive }) => ({
                  backgroundColor: isActive
                    ? sideBar?.activeNavBgColour
                    : sideBar?.bgColour,
                  color: isActive
                    ? sideBar?.activeNavTextColour
                    : sideBar?.textColour,
                })}
                className={({ isActive }) =>
                  `px-2 py-2 rounded-lg w-full flex items-center gap-1.5 text-sm border border-transparent transition-all ${
                    isActive
                      ? "bg-white text-black"
                      : "hover:border hover:border-white text-white"
                  }`
                }
              >
                <span className="text-xl">{item.icon}</span>
                <p className="sm:hidden lg:block">{item.title}</p>
              </NavLink>
            ) : (
              <div
                className={openDropdowns[item.title] ? "border-x border-b rounded-lg bg-[#0d0808]" : ""}
              >
                <button
                  onClick={() => toggleDropdown(item.title)}
                  style={{
                    backgroundColor: openDropdowns[item.title]
                      ? sideBar?.activeNavBgColour
                      : sideBar?.bgColour,
                    color: openDropdowns[item.title]
                      ? sideBar?.activeNavTextColour
                      : sideBar?.textColour,
                  }}
                  className={`px-2 py-2 rounded-lg w-full flex items-center justify-between gap-1.5 text-sm transition-all border border-transparent ${
                    openDropdowns[item.title] ? "bg-white text-black" : "text-white"
                  } hover:bg-black hover:text-white hover:border-white`}
                >
                  <div className="flex items-center gap-1.5">
                    <span className="text-xl">{item.icon}</span>
                    <p className="sm:hidden lg:block">{item.title}</p>
                  </div>
                  <span className="text-lg">
                    {openDropdowns[item.title] ? <CiCircleMinus /> : <CiCirclePlus />}
                  </span>
                </button>

                {openDropdowns[item.title] && (
                  <div className="ml-3 mr-1 my-2 space-y-1">
                    {item.subMenu.map((subItem, subIndex) => (
                      <NavLink
                        key={subIndex}
                        to={subItem.location}
                        className={({ isActive }) =>
                          `block px-2 py-2 rounded-lg text-sm transition-all ${
                            isActive ? "bg-gray-300 text-black" : "hover:bg-gray-700 text-white"
                          }`
                        }
                      >
                        {subItem.title}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;